<template>
  <el-dialog
    :visible.sync="$parent.dialogUrlVisible"
    :fullscreen="true"
    :destroy-on-close="true"
    :show-close="false"
    custom-class="url_dialog">
    <div class="url_view">
      <div class="page_top">
        <div class="title"><i class="icon" @click="$parent.dialogUrlVisible = false"></i></div>
      </div>
      <iframe :src="url" width="100%" height="100%">
      </iframe>
    </div>
  </el-dialog>
</template>
<script>

import FN from '@/components/fn'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'dialog',
  components: {
  },
  mixins: [FN],
  props: {
    name: String,
    url: String
  },
  data() {
    return {
      
    }
  },
  computed: {
  },
  methods: {
    handleClose() {
      this.$parent.dialogTermsVisible = false
    }
  }
}
</script>
